// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2HpVq","error":"Textarea_error__WjIf-","readonly":"Textarea_readonly__2xLZl","disabled":"Textarea_disabled__NLXeg"};